import { concat } from "@ember/helper";
import { computed } from "@ember/object";
import { reads } from "@ember/object/computed";
import { attributeBindings, classNames, tagName } from "@ember-decorators/component";
import { or } from "truth-helpers";
import icon from "discourse/helpers/d-icon";
import FormatSelectedContent from "select-kit/components/multi-select/format-selected-content";
import { resolveComponent } from "select-kit/components/select-kit";
import SelectKitHeaderComponent from "select-kit/components/select-kit/select-kit-header";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const MultiSelectHeader = dt7948.c(class MultiSelectHeader extends SelectKitHeaderComponent {
  static {
    dt7948.g(this.prototype, "caretUpIcon", [reads("selectKit.options.caretUpIcon")]);
  }
  #caretUpIcon = (dt7948.i(this, "caretUpIcon"), void 0);
  static {
    dt7948.g(this.prototype, "caretDownIcon", [reads("selectKit.options.caretDownIcon")]);
  }
  #caretDownIcon = (dt7948.i(this, "caretDownIcon"), void 0);
  static {
    dt7948.g(this.prototype, "ariaLabel", [reads("selectKit.options.headerAriaLabel")]);
  }
  #ariaLabel = (dt7948.i(this, "ariaLabel"), void 0);
  get caretIcon() {
    return this.selectKit.isExpanded ? this.caretUpIcon : this.caretDownIcon;
  }
  static {
    dt7948.n(this.prototype, "caretIcon", [computed("selectKit.isExpanded", "caretUpIcon", "caretDownIcon")]);
  }
  static {
    setComponentTemplate(precompileTemplate("\n    <div class=\"select-kit-header-wrapper\">\n      {{#each this.icons as |iconName|}}\n        {{icon iconName}}\n      {{/each}}\n\n      {{#if this.selectKit.options.useHeaderFilter}}\n        <div class=\"select-kit-header--filter\">\n          {{#if this.selectedContent.length}}\n            {{#let (resolveComponent this this.selectKit.options.selectedChoiceComponent) as |SelectedChoiceComponent|}}\n              {{#each this.selectedContent as |item|}}\n                <SelectedChoiceComponent @selectKit={{this.selectKit}} @item={{item}} />\n              {{/each}}\n            {{/let}}\n          {{/if}}\n\n          {{#let (resolveComponent this this.selectKit.options.filterComponent) as |FilterComponent|}}\n            <FilterComponent @selectKit={{this.selectKit}} @id={{concat this.selectKit.uniqueID \"-filter\"}} @hidePlaceholderWithSelection={{true}} />\n          {{/let}}\n        </div>\n      {{else}}\n        <FormatSelectedContent @content={{or this.selectedContent this.selectKit.noneItem}} @selectKit={{this.selectKit}} />\n\n        {{icon this.caretIcon class=\"caret-icon\"}}\n      {{/if}}\n    </div>\n  ", {
      strictMode: true,
      scope: () => ({
        icon,
        resolveComponent,
        concat,
        FormatSelectedContent,
        or
      })
    }), this);
  }
}, [attributeBindings("ariaLabel:aria-label"), classNames("multi-select-header"), tagName("summary")]);
export default MultiSelectHeader;